import React, { Component } from 'react';
import { connect } from 'react-redux';
import { nilError } from '../actions';
import Modal from 'react-modal';

const modalStyles = {
	content: {
		top					: '50%',
		left 				: '50%',
		right 			: 'auto',
		bottom			: 'auto',
		marginRight : '-50%',
		transform 	: 'translate(-50%, -50%)'
	}
}

Modal.setAppElement('#root');

class ModalOverlay extends Component {

	constructor (props) {
		super(props);

		this.openModal = this.openModal.bind(this);
		this.afterOpenModal = this.afterOpenModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.modalExists = this.modalExists.bind(this);
	}

	openModal() {
		;
	}

	afterOpenModal() {
		this.subtitle.style.color = '#a66';
	}

	closeModal() {
		this.props.nilError();
	}

	modalExists() {
		const me = (this.props.hinweis !== undefined && this.props.hinweis !== null);
		console.log("modal exists:", me);
		return me;
	}

	componentDidMount() {
		;
	}

	testSelected(id) {
		;
	}

  handleClick(e) {
		;
	}

	handleChange(e) {
		;
	}

	render() {
		if (this.props.hinweis) {
			console.log("hinweis:", this.props.hinweis.message);
		}

		const modalExists = this.modalExists();

		return (

			<div>
				{modalExists &&
					<Modal
						isOpen={this.props.hinweis !== undefined && this.props.hinweis !== null}
						onAfterOpen={this.afterOpenModal}
						onRequestClose={this.closeModal}
						style={modalStyles}
						contentLabel="Example Modal"
					>


					<h3 ref={subtitle => this.subtitle = subtitle}>Hinweis</h3>

					{this.props.hinweis !== null && <div>{this.props.hinweis.message}</div>}
					<button className="btn right" onClick={this.closeModal}>schließen</button>
				</Modal>
				}
			</div>

		);
	}
}

const mapDispatchToProps = {
	nilError
}

function mapStateToProps({ auth, hinweis }) {
	return { auth, hinweis }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: false })(ModalOverlay);



// WEBPACK FOOTER //
// ./src/components/ModalOverlay.js